module.exports = require("./ff-Latn-GM.d.ts");